export const booleanValueFormatter = ({ value }) => {
  try {
    return value ? 'SI' : 'NO';
  } catch {
    return '';
  }
};
